import React from "react";
import classNames from "classnames";
import * as AccordionRadix from "@radix-ui/react-accordion";
import type { AccordionContentProps } from "@radix-ui/react-accordion";

import styles from "./content.module.css";

type ContentProps = AccordionContentProps &
  React.RefAttributes<HTMLDivElement> & {
    children: string | React.ReactNode;
  };

const Content = React.forwardRef<HTMLDivElement, ContentProps>(
  ({ children, ...props }, forwardedRef) => {
    return (
      <AccordionRadix.Content
        {...props}
        ref={forwardedRef}
        className={classNames(
          "text-black-rock bg-white text-[16px] leading-[130%]",
          "data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden",
          styles.content
        )}
      >
        <div className={"px-3 pb-[14px] pt-0"}>{children}</div>
      </AccordionRadix.Content>
    );
  }
);

export default Content;
